import React from 'react';
import { motion } from 'framer-motion';
import { Sun } from 'lucide-react';
export function RealitySection() {
  return <section className="py-24 px-4 relative overflow-hidden" data-id="element-162">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-blue-900/10 rounded-full blur-[120px] -z-10 pointer-events-none" data-id="element-163"></div>

      <div className="max-w-3xl mx-auto text-center" data-id="element-164">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-165">
          <div className="inline-flex items-center justify-center p-3 bg-amber-500/10 rounded-full mb-6" data-id="element-166">
            <Sun className="w-8 h-8 text-amber-500" data-id="element-167" />
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-8 leading-tight" data-id="element-168">
            TU NUEVA REALIDAD EN 7 DÍAS
          </h2>

          <div className="space-y-6 text-xl text-slate-300 leading-relaxed" data-id="element-169">
            <p data-id="element-170">Imagina eliminar el miedo al "momento cero".</p>
            <p data-id="element-171">
              En menos de una semana, la mayoría de los hombres reportan no solo
              una mayor facilidad para lograr firmeza, sino una{' '}
              <span className="text-blue-400 font-semibold" data-id="element-172">
                presencia mental mucho más fuerte
              </span>
              .
            </p>
            <p className="font-bold text-white text-2xl mt-8" data-id="element-173">
              No es magia, es fisiología vascular recuperada.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}